import { render, staticRenderFns } from "./UnstakedNfts.vue?vue&type=template&id=2eab45fc&scoped=true&"
import script from "./UnstakedNfts.vue?vue&type=script&lang=js&"
export * from "./UnstakedNfts.vue?vue&type=script&lang=js&"
import style0 from "./UnstakedNfts.vue?vue&type=style&index=0&id=2eab45fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eab45fc",
  null
  
)

export default component.exports